var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1156"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1156"
    },
    "bundlingPackage": "academy-public-ui",
    "bundlingPackageVersion": "static-1.12135",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};